import { render, staticRenderFns } from "./CashIcon.vue?vue&type=template&id=10601117&scoped=true&"
import script from "./CashIcon.vue?vue&type=script&lang=ts&"
export * from "./CashIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10601117",
  null
  
)

export default component.exports